import React from 'react';
import { getSiteName } from '../utils/theme';

const Hero: React.FC = () => {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="pt-24 pb-16 px-4 min-h-screen flex items-center">
      <div className="container mx-auto text-center">
        <div className="max-w-4xl mx-auto">
          {/* Main Heading */}
          <h1 className="text-5xl md:text-7xl font-elegant font-bold text-white mb-6 leading-tight">
            <span className="bg-gradient-to-r from-mystic-400 to-moonlight-400 bg-clip-text text-transparent">
              {getSiteName()}
            </span>
            <br />
            <span className="text-3xl md:text-5xl text-lunar-200 font-elegant font-semibold">
              Умный ИИ-помощник
            </span>
          </h1>

          {/* Subtitle */}
          <p className="text-xl md:text-2xl text-lunar-300 mb-8 leading-relaxed font-elegant">
            Автоматизируйте создание контента с помощью передовых технологий искусственного интеллекта. 
            Повышайте продуктивность и качество работы с умным помощником нового поколения.
          </p>

          {/* Features List */}
          <div className="grid md:grid-cols-3 gap-6 mb-12 max-w-3xl mx-auto">
            <div className="bg-lunar-800/50 backdrop-blur-sm rounded-lg p-6 border border-[var(--primary-color-800-30)]">
              <div className="w-12 h-12 bg-mystic-gradient rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Мгновенная генерация</h3>
              <p className="text-lunar-400 text-sm">Получайте результат в реальном времени</p>
            </div>

            <div className="bg-lunar-800/50 backdrop-blur-sm rounded-lg p-6 border border-[var(--primary-color-800-30)]">
              <div className="w-12 h-12 bg-mystic-gradient rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Умная обработка</h3>
              <p className="text-lunar-400 text-sm">ИИ понимает контекст и нюансы</p>
            </div>

            <div className="bg-lunar-800/50 backdrop-blur-sm rounded-lg p-6 border border-[var(--primary-color-800-30)]">
              <div className="w-12 h-12 bg-mystic-gradient rounded-full flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-white mb-2">Безопасность</h3>
              <p className="text-lunar-400 text-sm">Ваши данные под надежной защитой</p>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button 
              onClick={() => {
                const pricingSection = document.getElementById('pricing');
                if (pricingSection) {
                  pricingSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              className="px-16 py-4 bg-mystic-gradient text-white text-lg font-semibold rounded-lg hover:shadow-xl hover:shadow-mystic-500/25 transition-all duration-300 transform hover:scale-105"
            >
              Попробовать
            </button>
          </div>

          {/* Scroll Indicator */}
          <div className="mt-16 animate-bounce">
            <svg className="w-6 h-6 text-mystic-400 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
            </svg>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;